import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Button,
  Chip,
  Dialog,
  TextField,
  IconButton,
  Tooltip,
  Autocomplete,
} from "@mui/material";
import AddCircleIcon from "@mui/icons-material/AddCircle";

export default function FilterSearch(props) {
  const [open, setOpen] = React.useState(false);
  const [state, setState] = useState(null);
  const [searchState, setSearchState] = useState([]);
  const [add, setAdd] = useState("");

  const States = [
    { id: 1, label: "تایید" },
    { id: 2, label: "عدم تایید" },
    { id: 3, label: "در انتظار" },
  ];

  const adds = [
    { id: 1, label: "اضافه" },
    { id: 2, label: "کسر" },
  ];

  useEffect(() => {
    if (!props.add) {
      setAdd("");
    }
    if (!props.state) {
      setState("");
    }
  }, [props]);

  return (
    <Box
      sx={{
        gap: 2,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        mb: 2,
        width: "100%",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <Typography variant="subtitle1">فیلترها : </Typography>
        <Tooltip title="افزودن">
          <IconButton onClick={() => setOpen(true)}>
            <AddCircleIcon
              sx={{
                color: "primary.main",
              }}
            />
          </IconButton>
        </Tooltip>
        <Box
          style={{ direction: "ltr", display: "flex", alignItems: "center" }}
        >
          {props.add && (
            <Chip
              label={adds.find((m) => m.id == props.add)?.label}
              onDelete={(data) => {
                props.setAdd("");
                setAdd("");
              }}
              color="primary"
              sx={{
                px: 2,
                m: 0.5,
                "& .MuiChip-label	": {
                  px: 0,
                },
              }}
            />
          )}
          {props.state && (
            <Chip
              label={States.find((m) => m.id == props.state)?.label}
              onDelete={(data) => {
                props.setState("");
                setState("");
              }}
              color="primary"
              sx={{
                px: 2,
                m: 0.5,
                "& .MuiChip-label	": {
                  px: 0,
                },
              }}
            />
          )}
        </Box>
      </Box>
      <Box>
        <TextField
          placeholder=" موبایل"
          fullWidth
          value={searchState}
          onChange={(evt) => {
            if (evt.target.value == "") {
              props.setMobile("");
            }
            setSearchState(evt.target.value);
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              props.setMobile(searchState);
            }
          }}
        />
      </Box>
      <Dialog
        maxWidth="sm"
        fullWidth
        onClose={() => setOpen(false)}
        open={open}
      >
        <Box
          sx={{ m: 3, my: 5 }}
          display="grid"
          gridTemplateColumns="repeat(12, 1fr)"
          gap={3}
        >
          <Box gridColumn="span 6">
            <Autocomplete
              size="small"
              value={state ? state : ""}
              onChange={(event, newValue) => {
                if (newValue) {
                  setState(newValue);
                } else {
                  setState("");
                }
              }}
              isOptionEqualToValue={(option, value) => option.id === value.id}
              getOptionLabel={(option) => {
                if (option) {
                  return States.find((m) => m.id == option).label;
                }
                return "";
              }}
              options={States ? States.map((m) => m.id) : []}
              renderInput={(params) => (
                <TextField variant="outlined" {...params} label="وضعیت" />
              )}
            />
          </Box>
          <Box gridColumn="span 6">
            <Autocomplete
              size="small"
              value={add ? add : ""}
              onChange={(event, newValue) => {
                if (newValue) {
                  setAdd(newValue);
                } else {
                  setAdd("");
                }
              }}
              isOptionEqualToValue={(option, value) => option.id === value.id}
              getOptionLabel={(option) => {
                if (option) {
                  return adds.find((m) => m.id == option).label;
                }
                return "";
              }}
              options={adds ? adds.map((m) => m.id) : []}
              renderInput={(params) => (
                <TextField variant="outlined" {...params} label="از نوع" />
              )}
            />
          </Box>
          <Box
            gridColumn="span 12"
            sx={{ display: "flex", justifyContent: "center", mx: "auto" }}
          >
            <Button
              variant="contained"
              onClick={() => {
                props.setAdd(add);
                props.setState(state);
                setOpen(false);
              }}
              sx={{ width: "70px", mr: 2 }}
            >
              ثبت
            </Button>
            <Button
              variant="outlined"
              onClick={() => {
                setOpen(false);
              }}
              sx={{ width: "70px" }}
            >
              انصراف
            </Button>
          </Box>
        </Box>
      </Dialog>
    </Box>
  );
}
